import polygonClipping from "polygon-clipping";
import sqftEventManager from "../../store/sqftEventManager";
// import triangle from "./layouts/triangle";
import Line from "./line";
import pnpoly, {pnpolyArray} from "../../../../lib/pnpoly";
//import earcut from "../../../../lib/earcut";
import workspace from "../workspace";
//import sqftStore from "../../store/sqftStore";
import sqftStore from "../workspace";
import sqftConfig from "../../store/sqftConfig";
import {
  getAreaByShoelaceFormula,
  getEdgeArea, getIntersectCordsBetweenLines, getPointDistance, getPointField,
  getSnappedPos,
  inchesToLNFT,
  isIOSDeviceV2,
  mm2ToM2,
  mmToM,
  orientation,
  rotatePoint,
  sqInchesToMM2,
  sqInchesToSqFoot
} from "../../../../helpers/sqftHelper";
import {getAngle, getRotationCentrePoint} from "./rotation";
import ShapeHelper, {
  getAngleBetween3Points,
  getPointDirection, getShapeAxes,
  setShapeDepth,
  setShapeDepthWithAutoShift,
  setShapeWidthWithAutoShift,
  setShapeWidth,
} from "../../../../helpers/shapeHelper";
import $ from "jquery";
import clone from "lodash/clone";
import store from "../../../../../../store";
import {
  CABINET_BOXES,
  FEATURE_QUANTITY_UNITS,
  SHAPE_PART_ID, SHAPE_PART_IDS_USING_SAME_COLOR, SIDEBAR_BUTTONS_MENU,
  SIDEBAR_SLAB_SEAM_BUTTONS, WORKSPACE_RESOURCES,
} from "../../../../constants";
import ShapeSlab from "./shapeParts/shapeSlab";
import config from "../../store/sqftConfig";
import SlabWorkspace from "../slab/slabWorkspace";
import ShapeEditable from "./shapeParts/shapeEditable";
import {updateSQFTCalculations} from "../../../../../../actions/sqftFunctions";
import sqftShapeManager from "../../store/sqftShapeManager";
import SqftStore from "../../store/sqftStore";
import ShapeCabinet from "./shapeParts/shapeCabinet";
import ShapeAbsolute from "./shapeParts/shapeAbsolute";
import ShapeSpacer from "./shapeParts/shapeSpacer";
import {isSFTCabinetsGroup} from "../../../../helpers/sqftNavigationHelper";
import {getCurrentLayout} from "../../../../../appLayout";
import {
  getFeatureNameById,
  shouldChangeCabinetShapePartId
} from "../../../../helpers/featureHelper";
import {
  addShapeIdWithMissingFeature,
  setShouldShowChangeShapeFeatureMissingMessage,
  setSQFTActiveShapeId,
} from "../../../../../../actions/sqftMenuFunctions";
import workspaceControllers from "../../store/workspaceControllers";
import sqftSlabManager from "../../store/sqftSlabManager";
import ShapeIntersections from "./shapeParts/shapeIntersections";
import ShapeMemory from "./shapeParts/shapeMemory";
import ShapeRender from "./shapeParts/shapeRender";
import {SHAPE_PART_IDS_VISIBLE_ONLY_IN_THE_SLAB_MODE} from "../../../../constantsFeature";
import CabinetSwitchers from "../../../../../kvComponent/navigation/cabinetSwitchers";
import ShapeAutoShuffle from "./shapeParts/shapeAutoShuffle";
import {getLinesWithoutAnglePoints} from "../../helpers/lineHelper";
import {SHAPE_DIAMOND_LAYOUTS, SHAPE_LAYOUTS} from "../cabinet/cabinetShapes";
import {getCabinetSimilarFeatureFromAnotherColor} from "../../../../helpers/sqft3dArHelper";
import {
  calculatePolygonClippingPolygonArea,
  getPointsCoordsFromShape,
  getRotatedPointV1
} from "../../../../helpers/coordinatesHelper";
import {
  getCabinetDoorsSQFT,
  getCabinetLNFT,
  getQuantityFromFiltersByShapes
} from "../../../../helpers/sqftCalculations";
import {initTitle} from "../controls/labels/labelsHelper";
import {SLAB_IMAGE_TYPES} from "../../../../../../reducers/sqft/sqftSlabReducer";
import sqftShapeIntersectionsManager from "../../store/sqftShapeIntersectionsManager";
import sqftImageManager from "../../store/sqftImageManager";
import {getWizardPropertiesForFeatureId} from "../controls/resourseCanas";

export default function(id, totalShapeCount, shapeType, partId, fromLayout, shapeParams = {}) {
  //private variables
  let self = this,
    shape = null,
    // debugLineColor = "rgba(0,255,0,0.3)",
    // debugPointColor = "rgba(0,0,255,0.3)",
    // fillColor = "rgba(255,255,255,0)",
    minAngle = -90,
    maxAngle = 90,
    marginFromShape = SqftStore.isSlabMode() || isSFTCabinetsGroup() ? 0 : 30,
    state = {
      mouseDown: false,
      mouseDownPosition: null,
      hovering: false,
      handlerHold: null,
      isPointsMovable: false,
      isRotatable: false,//true //todo enable on menu click
      wasDragging: false,
    };
  this.design = {
    hoverShapeColor: "rgba(159,197,34,0.47)",
    redHoverShapeColor: "rgba(208,1,27,0.5)",
    fillColor: "rgba(74,144,226,0.17)",
  }
  this.layout270 = ["SN", "SPN", "SNI", "SPNI"];
  this.shapeParams = shapeParams; //{shapeCabinet: boolean, canSnap: boolean, isSpacer: boolean}
  //public properties
  this.pos = {
    x: 0,
    y: 0
  };
  this.slabPos = {
    x: 0,
    y: 0
  };
  this.staticCenterPoint = null;
  this.testShapeLines = null;
  this.linesWithoutAngle = null;
  this.shapeSlab = new ShapeSlab(this);
  this.shapeCabinet = shapeParams.shapeCabinet ? new ShapeCabinet(this) : null;
  //this.shapeAbsolute = shapeParams.canSnap ? new ShapeAbsolute(this) : null;
  this.shapeAbsolute = new ShapeAbsolute(this);
  this.shapeSpacer = shapeParams.isSpacer ? new ShapeSpacer(this) : null;
  this.shapeEditable = new ShapeEditable(this);
  this.shapeIntersections = new ShapeIntersections(this);
  this.shapeAutoShuffle = new ShapeAutoShuffle(this);
  this.shapeMemory = new ShapeMemory(this);
  this.shapeRender = new ShapeRender(this);
  this.shapeRotatable = null; //new ShapeRotatable(this, fillColor);
  this.colorSet = null; //new ColorSet
  this.shapePieces = []; // seam parts shape ids (see seam tool)
  this.bumpoutPieces = []; // bumpout shape ids (in slab mode)
  this.seamCutPoints = [];
  this.seamCutPointsAndLines = []; // new PointAndLine
  this.shapeParentId = null;
  this.slabModeCoreParentId = null; // shape id (additional backsplash shape parent shape id in the slab mode. See SlabAdditionalShapes)
  this.id = id;
  this.feature = null; // use getFeature
  this.featureId = null;
  this.featureName = null;
  this.relatedParentFeatureId = null;
  this.fromWizardId = null;
  this.fromWizardStep = null;
  this.fromWizardGroupId = null;
  this.relatedParentFeatureFromWizardId = null;
  this.relatedParentFeatureFromWizardStep = null;
  this.relatedParentFeatureFromWizardGroupId = null;
  this.shapeType = shapeType;
  this.isContextMenuActive = false;
  this.labelsMenu = null;
  this.partId = partId;
  this.parentPartId = null; // this is shape part id that shape was created from. Used for spacer shapes
  this.slabParentPartId = null; // this is the shape partId that is hovered the slab. Used for slabs. Or shape part id that shape was created from in the slab mode.
  this.qtCatName = null;
  this.fromLayout = fromLayout; // layout abbreviation (S, LNI, etc.) is needed to know if to show popup
  this.rotatedDegrees = 0;
  this.rotatedDegreesSlab = 0;
  this.isHidden = false;
  this.isPointsMoved = false; // true if any shape points was moved
  this.isPointsChanged = true; // used to trigger update points position for the slabMode
  this.isPositionChanged = true; // used to trigger update slabPosition for the slabMode
  this.isResetSlabModePopupWasDisplayed = false; //used to display reset popup window if shape has pieces
  this.Direction = {
    RIGHT: 0,
    LEFT: 1
  };
  this.FlipDirection = {
    HORIZONTAL: 0,
    VERTICAL: 1
  };
  this.rotateAngleParts = getAngleRotatedParts(shapeType);
  this.isDisabledInPopup = false;
  this.slabModeWaterfallSegmentId = null;
  this.shouldUseSlabPricing = false;
  this.originalPointsCoords = [];
  this.shouldAddCabinetBox = sqftConfig.shouldAddCabinetBoxes || false;
  this.shapeHeight = null;

  this.getState = () => { return state };
  this.getFillColor = () => { return this.design.fillColor };
  this.getDesign = () => { return this.design };
  this.getColorset = () => { return this.colorSet };
  this.getIsPointsMovable = () => { return state.isPointsMovable };
  this.setType = (type) => { self.type = type };
  this.setProperty = (name, value) => { self[name] = value };
  this.setId = (id) => { this.id = id };
  this.setPartId = (partId) => {self.partId = partId};
  this.getFeatureName = () => { return this.featureName};
  this.setFeatureName = (featureName) => { this.featureName = featureName};
  this.setFeatureId = (featureId) => {
    //console.log("cur featureId", this.featureId);
    //console.log("new featureId", featureId);
    if (featureId !== this.featureId) {
      this.featureId = featureId
      this.featureName = getFeatureNameById(featureId);
      this.feature = null;
      if (this.shapeCabinet) {
        // workspaceControllers.handles.addOrChangeHandlesToTheShape();
        // workspaceControllers.hinge.addOrChangeHandlesToTheShape();
        const existingHandles = workspaceControllers.handles.getAllResourcesForTheShape(shape.id);
        if (existingHandles.length) {
          this.shapeCabinet.deleteAttachedFeatures();
          this.shapeCabinet.generateAttachedFeatures();
        }
      }
      const isShapeUseTheSameFeatureColor = Object.values(SHAPE_PART_IDS_USING_SAME_COLOR).includes(this.partId);
      const isSeamPiece = this.partId === SHAPE_PART_ID.seamPiece;
      if (isShapeUseTheSameFeatureColor || isSeamPiece) {
        this.updateColorSet();
        this.updateRelatedShapes();
        this.updateSeamShapes();
        this.updateBumpoutShapes();
      }

      //Update placeholder name
      if (this.partId === SHAPE_PART_ID.slabPlaceHolder) {
        const featureName = this.getFeature().getFeatureName();
        initTitle(featureName, SLAB_IMAGE_TYPES.placeholder, this);
        if (!SqftStore.isSlabMode()) {
          this.deregisterLineEvents();
        }
      }

      // Update wizard properties (only if we have new flow selected)
      this.updateWizardProperties();

      // Changed countertop must set feature for the slab/placeholder placed on it.
      sqftShapeIntersectionsManager.syncSlabFeaturesFromCountertopShape(this.id);
      //if (true) {
        // sqftShapeIntersectionsManager.updateShapesIntersections();
        // sqftShapeIntersectionsManager.updateSlabPlaceholderFeatureId();
        // //sqftShapeIntersectionsManager.updateShapesFeaturePlacedOnSlabImages();
        // sqftShapeIntersectionsManager.updateSlabImagesFeature();


        // first we need to handle wizard conflicts and then we will proceed with slab conflicts
        //this.shapeIntersections.handleSlabPlaceholderIntersections(true);

        //const slabPlaceHolderShapes = sqftSlabManager.getSlabPlaceHolderShapes();
        //sqftShapeIntersectionsManager.showSlabPlaceHolderErrorMessage(slabPlaceHolderShapes);
        //this.shapeIntersections.handleSlabPlaceholderIntersections();
        //this.shapeIntersections.handleSlabImageIntersections();
      //}
    }
  };
  this.getFeature = () => {
    if (!this.feature) {
      const layout = getCurrentLayout();
      this.feature = layout.getFeatureById(this.featureId, true);
    }
    return this.feature
  }
  this.setRelatedParentFeatureId = (relatedParentFeatureId) => {
    this.relatedParentFeatureId = relatedParentFeatureId;
    this.relatedParentFeature = null;
    this.updateRelatedFeatureWizardProperties();
  }
  this.getRelatedParentFeature = () => {
    if (!this.relatedParentFeature) {
      const layout = getCurrentLayout();
      this.relatedParentFeature = layout.getFeatureById(this.relatedParentFeatureId, true);
    }
    return this.relatedParentFeature
  }
  this.setSlabParentPartId = (partId) => { this.slabParentPartId = partId }; // here we will assign shape part id that is hovered the slab
  this.setSlabModeCoreParentPartId = (partId) => { this.slabParentPartId = partId }; // here we will assign core shape part id
  this.setSlabModeCoreParentId = (id) => { this.slabModeCoreParentId = id };
  this.setSlabModeWaterfallSegmentId = (id) => {this.slabModeWaterfallSegmentId = id};
  this.setColorSet = (colorSet) => {this.colorSet = colorSet};
  this.getColorSet = () => { return this.colorSet};
  this.updateColorSet = () => {
    this.colorSet = workspaceControllers[WORKSPACE_RESOURCES.shapeColors]
      .getOrGenerateNewShapeColorByFeatureId(this.featureId);
  };
  this.updateWizardProperties = () => {
    let {fromWizardId, fromWizardStep, fromWizardGroupId} = getWizardPropertiesForFeatureId(this.featureId);
    // update wizardGroup only if we have new flow selected
    if (fromWizardStep) {
      this.fromWizardId = fromWizardId;
      this.fromWizardStep = fromWizardStep;
      this.fromWizardGroupId = fromWizardGroupId;
    }
  };
  this.updateRelatedFeatureWizardProperties = () => {
    let {fromWizardId, fromWizardStep, fromWizardGroupId} = getWizardPropertiesForFeatureId(this.relatedParentFeatureId);
    // update wizardGroup only if we have new flow selected
    if (fromWizardStep) {
      this.relatedParentFeatureFromWizardId = fromWizardId;
      this.relatedParentFeatureFromWizardStep = fromWizardStep;
      this.relatedParentFeatureFromWizardGroupId = fromWizardGroupId;
    }
  };
  this.updateRelatedShapes = () => {
    const relatedShapes = workspace.getShapesBySlabModeCoreParentId([this.id])
      .filter(shp => shp.partId === this.partId);

    for (const relatedShape of relatedShapes) {
      relatedShape.setFeatureId(this.featureId);
      relatedShape.setColorSet(this.colorSet);
    }
  };
  this.updateSeamShapes = () => {
    this.shapePieces.forEach(shapePieceId => {
      let shapePiece = workspace.getShapeById(shapePieceId);
      shapePiece.setFeatureId(this.featureId);
      shapePiece.setColorSet(this.colorSet);
    });
  };
  this.updateBumpoutShapes = () => {
    this.bumpoutPieces.forEach(shapePieceId => {
      let shapePiece = workspace.getShapeById(shapePieceId);
      shapePiece.setFeatureId(this.featureId);
      shapePiece.setColorSet(this.colorSet);
    });
  };
  this.updateSeamedShapesPosition = () => {
    this.shapePieces.forEach(shapePieceId => {
      let shapePiece = workspace.getShapeById(shapePieceId);
      shapePiece.setPositionWithoutChange(this.pos);
    });
  };
  this.setQtCatName = (qtCatName) => {this.qtCatName = qtCatName};
  this.setIsPointsChanged = (isPointsChanged) => {this.isPointsChanged = isPointsChanged};
  this.addCrownMolding = () => {
    this.shapeCabinet ? this.shapeCabinet.addCrownMolding() : null;
  }
  this.setQtCatName = (qtCatName) => { this.qtCatName = qtCatName };
  this.getIsRotatable = () => { return state.isRotatable };
  this.setIsRotatable = (isRotatable) => { state.isRotatable = isRotatable };
  this.setIsPointsMovable = (isPointsMovable) => { state.isPointsMovable = isPointsMovable };
  this.setSlabPricing = (value) => { this.shouldUseSlabPricing = value };
  this.setShouldAddCabinetBox = (value) => { this.shouldAddCabinetBox = value };
  this.getIsDisabledInPopup = () => { this.isDisabledInPopup };
  this.setIsDisabledInPopup = (value) => {
    const hinges = workspaceControllers.hinge.getAllResourcesForTheShape(this.id);
    const handles = workspaceControllers.handles.getAllResourcesForTheShape(this.id);
    for (const handle of handles) {
      handle.setIsDisabledInPopup(value);
    }
    for (const hinge of hinges) {
      hinge.setIsDisabledInPopup(value);
    }

    this.isDisabledInPopup = value
  };

  /**
   * this will return size for square and rectangles in INCHES
   * todo maybe we need to change this and return values in mmm and inches
   * @return {{width: *, height: *}}
   */
  this.getSize = () => {
    return {
      width: getPointDistance(shape[0].from, shape[0].to),
      depth: getPointDistance(shape[1].from, shape[1].to),
    }
  }
  this.updateMouseDown = (mousePos = sqftEventManager.getMousePos()) => {
    state.mouseDown = true;
    state.mouseDownPosition = mousePos;
  }
  this.resetMouseDown = () => {
    state.mouseDown = false;
    state.mouseDownPosition = null;
  }

  this.getInitialWidth = () => {
    return this.shapeParams.width
  }

  this.getInitialDepth = () => {
    return this.shapeParams.depth
  }

  this.getInitialHeight = () => {
    return this.shapeParams.height
  }

  this.getWidth = () => {
    const axes = getShapeAxes(this);
    const points = this.getLines().map(l => l.from);
    const projections = points.map(pt => pt.x * Math.cos(axes.widthAxis) + pt.y * Math.sin(axes.widthAxis));

    return Math.round10(Math.max(...projections) - Math.min(...projections));
  }

  this.getDepth = () => {
    const axes = getShapeAxes(this);
    const points = this.getLines().map(l => l.from);
    const projections = points.map(pt => pt.x * Math.cos(axes.depthAxis) + pt.y * Math.sin(axes.depthAxis));

    return Math.round10(Math.max(...projections) - Math.min(...projections));
  }

  this.getHeight = () => {
    // custom height
    if (this.shapeHeight) {
      return this.shapeHeight
    }
    // initial height
    return this.shapeParams.height
  }

  this.setWidth = (newWidth) => {
    void setShapeWidth; //void setShapeWidth(this, newWidth)
    setShapeWidthWithAutoShift(this, newWidth);
  }

  this.setDepth = (newDepth) => {
    void setShapeDepth;
    setShapeDepthWithAutoShift(this, newDepth);
  }

  this.setHeight = (value) => {
    this.shapeHeight = value;
  }
  this.setInflectionPoints = (points) => {
    this.inflectionPoints = points
  }
  this.getInflectionPoints = () => {
    return this.inflectionPoints
  }
  //public events
  this.onHover = null;

  //private setters
  function getAngleRotatedParts(shapeType) {
    switch (shapeType) {
      case "horseshoe":
        return [{ // this is the right part: |‾| <- this one
          rotatedAngleValue: 0, // angle input value
          line1: 1, // right external side
          line2: 3, // right internal side
          baseConfiguration: null, // is used for keeping all the configuration after rotateAngle is over
          isHovered: false, // user has mouse over this part
          isActive: false, // user has clicked on this part
          isPulsing: true, // user has select angle tool
          shapeType, // is needed for onChange, different parts have different point changes
          angleDirection: "right" // rotate direction (is used for lines, line text, etc.)
        }, {  // this is the left part: this one -> |‾|
          rotatedAngleValue: 0, // angle input value
          line1: 7, // left external side
          line2: 5, // left internal side
          baseConfiguration: 0, // difference between basePointX and secondaryPointX
          isHovered: false, // user has mouse over this part
          isActive: false, // user has clicked on this part
          isPulsing: true, // user has select angle tool
          shapeType, // is needed for onChange, different parts have different point changes
          angleDirection: "left"  // rotate direction (is used for lines, line text, etc.)
        }];
      case "wideangle":
        return [{ // this is the top part: |‾ <- this one
          rotatedAngleValue: 0, // angle input value
          line1: 0, // top external side
          line2: 2, // top internal side
          baseConfiguration: null, // is used for keeping all the configuration after rotateAngle is over
          isHovered: false, // user has mouse over this part
          isActive: false, // user has clicked on this part
          shapeType, // is needed for onChange, different parts have different point changes
          angleDirection: "right" // rotate direction (is used for lines, line text, etc.)
        }, {  // this is the left part: this one -> |‾
          rotatedAngleValue: 0, // angle input value
          line1: 5, // left external side
          line2: 3, // left internal side
          baseConfiguration: 0, // difference between basePointX and secondaryPointX
          isHovered: false, // user has mouse over this part
          isActive: false, // user has clicked on this part
          shapeType, // is needed for onChange, different parts have different point changes
          angleDirection: "left" // rotate direction (is used for lines, line text, etc.)
        }];
      default:
        return []
    }
  }

  const setFillColor = (red, green, blue, alpha) => {
    this.design.fillColor =
      "rgba(" + red + ", " + green + ", " + blue + ", " + alpha + ")";
  }

  this.setPosition = (value) => {
    this.pos = value;
    this.isPositionChanged = true;
    this.updateSeamedShapesPosition();
  }
  this.setPositionWithoutChange = (value) => {
    this.pos = value;
    this.updateSeamedShapesPosition();
    // if (this.partId !== SHAPE_PART_ID.backsplashPiece && this.partId !== SHAPE_PART_ID.seamPiece) {
    //   this.isPositionChanged = true;
    // }
  }
  this.setSlabPosition = (value) => {
    this.slabPos = clone(value);
  }
  this.setLines = (segments) => {
    shape = segments; // [line, line, line, line]
    for (let i = 0; i < shape.length; i++) {
      shape[i].init(self);
    }
  }
  this.destroyLines = () => {
    for (let i = 0; i < shape.length; i++) {
      shape[i].destroy();
    }
  }
  this.changeLines = (segments) => {
    this.destroyLines();
    this.setLines(segments)
  }
  function setHovering(value) { state.hovering = value; return value; }
  function setHoveringOnlyShape(value) { state.hoveringOnlyShape = value; return value; }
  //public getters
  this.getPosition = () => {
    const reduxState = store.getState();
    const isShowSlabTool = reduxState.sqftSlabState.isShowSlabTool;
    let pos;

    if (isShowSlabTool) {
      let slabAbsolutePos = this.getSlabAbsolutePosition()
      pos = slabAbsolutePos ? slabAbsolutePos : this.slabPos;
    } else if (this.shapeParams !== undefined && this.shapeParams.canSnap) {
      let absolutePos = this.shapeAbsolute.getAbsolutePosition();
      pos = absolutePos !== null ? absolutePos : this.pos;
    } else {
      pos = this.pos
    }

    return pos;
  };
  this.getOffset = () => {
    const scale = config.scale;
    const workspacePos = workspace.getOffset();
    let _pos = this.getPosition();
    if (config.workspace.snapToGrid) {
      _pos = this.getSnappedPosition();
    }
    return {
      x: workspacePos.x + (_pos.x * scale),
      y: workspacePos.y + (_pos.y * scale)
    }
  };
  this.getRegularPosition = () => { return this.pos; };
  this.getSlabPosition = () => { return this.slabPos; };
  this.getSlabAbsolutePosition = () => { return this.shapeSlab.getAbsolutePosition(); };
  this.getSnappedPosition = () => { return getSnappedPos(this.getPosition()) };
  //todo
  this.isHovering = (shouldUpdateHovering = false) => {
    if (shouldUpdateHovering) {
      isMouseOverShape(sqftEventManager.getMousePos());
    }
    const isSlabMode = SqftStore.isSlabMode();
    if (!isSlabMode) {
      for (const line of this.getLines()) {
        if (line.isHovering(isSlabMode)) {
          return true
        }
      }
    }
    return state.hovering === true;
  };
  this.isHoveringOnlyShape = function() { return state.hoveringOnlyShape === true; };
  this.isWithShapePieces = () => {
    return this.shapePieces.length > 0;
  };
  this.setResetSlabModePopupWasDisplayed = (value) => {
    return this.isResetSlabModePopupWasDisplayed = value;
  };
  this.getResetSlabModePopupWasDisplayed = () => {
    return this.isResetSlabModePopupWasDisplayed;
  };
  this.setShapePieces = (shapePieces) => {
    this.shapePieces = shapePieces;
  };
  this.addShapePieceId = (shapeId) => {
    this.shapePieces.push(shapeId);
  };
  this.hideShapePieces = () => {
    this.shapePieces.forEach(shapePieceId => {
      let shapePiece = workspace.getShapeById(shapePieceId);
      if (shapePiece) {
        shapePiece.deregisterEvents()
      } else {
        console.error("shapePiece with Id not found", shapePieceId);
      }
    });
  };
  this.restoreShapePieces = () => {
    this.shapePieces.forEach(shapePieceId => {
      let shapePiece = workspace.getShapeById(shapePieceId);
      shapePiece.reInitEvents();
    });
  };
  this.removeShapePieces = () => {
    this.shapePieces.forEach(shapePieceId => {
      workspace.removeShapeById(shapePieceId);
    });
  };

  this.export = () => {
    let lines = [];
    let doors = 0;
    let drawers = 0;
    let cabinetDoorsAndDrawersQuantity = 0;
    let cabinetDoorsSQFT = 0;
    let cabinetDoorsLNFT = 0;
    let totalArea = this.getTotalArea();
    let quantity = sqftConfig.measureUnit === "Imperial" ? Math.ceil10(sqInchesToSqFoot(totalArea), -2) : mm2ToM2(self.getTotalArea(totalArea));
    if (sqftConfig.shouldUseCabinetDoorsSQFT && FEATURE_QUANTITY_UNITS.includes(this.partId)) {
      cabinetDoorsSQFT = getCabinetDoorsSQFT(this);
      cabinetDoorsSQFT = config.measureUnit === "Imperial" ? Math.ceil10(sqInchesToSqFoot(cabinetDoorsSQFT), -2) : mm2ToM2(cabinetDoorsSQFT);
    } else if (sqftConfig.shouldUseCabinetDoorsLNFT && FEATURE_QUANTITY_UNITS.includes(this.partId)) {
      cabinetDoorsLNFT = getCabinetLNFT(this);
      cabinetDoorsLNFT = config.measureUnit === "Imperial" ? Math.ceil10(cabinetDoorsLNFT, -2) : mmToM(cabinetDoorsLNFT);
    } else if (sqftConfig.shouldUseCabinetDoorsAndDrawersQuantity && FEATURE_QUANTITY_UNITS.includes(this.partId)) {
      doors = +getQuantityFromFiltersByShapes([this], 'Number_of_Doors');
      drawers = +getQuantityFromFiltersByShapes([this], 'Number_of_Drawers');
      cabinetDoorsAndDrawersQuantity = doors + drawers;
    }

    if (FEATURE_QUANTITY_UNITS.includes(this.partId)) {
      quantity = 1
    }

    for (let i = 0; i < shape.length; i++) {
      lines.push(shape[i].export());
    }
    let isHidden = [SHAPE_PART_ID.seamPiece, SHAPE_PART_ID.slabPlaceHolder].includes(this.partId);

    return {
      pos: this.pos,
      slabPos: this.slabPos,
      id: this.id,
      featureId: this.featureId,
      features: [
        {
          featureId: this.featureId,
          featureName: this.getFeature()?.getFeatureName(),
          partId: this.partId,
        }, {
          featureId: this.relatedParentFeatureId,
          partId: this.parentPartId,
        }
      ],
      colorSet: this.colorSet,
      type: this.type,
      isHidden: isHidden,
      shapePieces: this.shapePieces,
      bumpoutPieces: this.bumpoutPieces,
      //seamCutPointsAndLines: this.seamCutPointsAndLines, // this causes critical error on saving quote
      shapeParentId: this.shapeParentId,
      lines: lines,
      shapeType: this.shapeType,
      rotatedDegrees: this.rotatedDegrees,
      rotatedDegreesSlab: this.rotatedDegreesSlab,
      partId: this.partId,
      qtCatName: this.qtCatName,
      fromLayout: this.fromLayout,
      squareFeet: quantity,
      quantity: quantity,
      quantitySubParts: {
        doors,
        drawers,
        cabinetDoorsAndDrawersQuantity,
        cabinetDoorsSQFT,
        cabinetDoorsLNFT
      },
      isDisabledInPopup: this.isDisabledInPopup,
      rotateAngleParts: this.rotateAngleParts,
      isPointsChanged: this.isPointsChanged,
      isPositionChanged: this.isPositionChanged,
      isResetSlabModePopupWasDisplayed: this.isResetSlabModePopupWasDisplayed,
      shapeSlab: this.shapeSlab.export(),
      shapeCabinet: this.shapeCabinet ? this.shapeCabinet.export() : null,
      shapeAbsolute: this.shapeAbsolute ? this.shapeAbsolute.export() : null,
      shapeParams: this.shapeParams,
      relatedParentFeatureId: this.relatedParentFeatureId,
      fromWizardId: this.fromWizardId,
      fromWizardStep: this.fromWizardStep,
      fromWizardGroupId: this.fromWizardGroupId,
      relatedParentFeatureFromWizardId: this.relatedParentFeatureFromWizardId,
      relatedParentFeatureFromWizardStep: this.relatedParentFeatureFromWizardStep,
      relatedParentFeatureFromWizardGroupId: this.relatedParentFeatureFromWizardGroupId,
      slabModeCoreParentId: this.slabModeCoreParentId,
      parentPartId: this.parentPartId,
      slabParentPartId: this.slabParentPartId,
      shouldUseSlabPricing: this.shouldUseSlabPricing,
      originalPointsCoords: this.originalPointsCoords,
      shouldAddCabinetBox: this.shouldAddCabinetBox,
      shapeHeight: this.shapeHeight,
    };
  };
  this.import = (value) => {
    const reduxState = store.getState();
    const {sqftFromFeature} = reduxState.sqftState;

    ["fromLayout", "id", "partId", "shapeType", "rotatedDegrees", "rotatedDegreesSlab", "rotateAngleParts", "fromLayout",
      "type", "isHidden", "shapePieces", "bumpoutPieces", "pos", "slabPos", "featureId", "isDisabledInPopup", "isPointsChanged",
      "isPositionChanged", "qtCatName", "isResetSlabModePopupWasDisplayed", "shapeParams", "shapeCabinet", "shapeAbsolute",
      "relatedParentFeatureId", "colorSet", "fromWizardGroupId", "fromWizardId", "fromWizardStep", "slabModeCoreParentId",
      "parentPartId", "slabParentPartId", "shouldUseSlabPricing", "originalPointsCoords", "features", "shouldAddCabinetBox",
      "shapeHeight", "relatedParentFeatureFromWizardId", "relatedParentFeatureFromWizardStep", "relatedParentFeatureFromWizardGroupId",
    ]
      .forEach(key => {
        self[key] = value[key]
      });
    let lines = [];
    for (let i = 0; i < value.lines.length; i++) {
      let line = new Line();
      line.import(value.lines[i], lines, this);
      lines.push(line);
    }
    shape = lines;
    for (let i = 0; i < shape.length; i++) {
      shape[i].init(this);
    }
    this.init();
    this.shapeSlab.import(value.shapeSlab);
    if (value.shapeCabinet) {
      this.shapeCabinet = new ShapeCabinet(this);
      this.shapeCabinet.import(value.shapeCabinet);
    }
    if (value.shapeAbsolute) {
      this.shapeAbsolute = new ShapeAbsolute(this);
      this.shapeAbsolute.import(value.shapeAbsolute);
    }
    if ([SHAPE_PART_ID.slabPlaceHolder, SHAPE_PART_ID.seamPiece].includes(value.partId)) {
      this.deregisterEvents();
    }
    if (isSFTCabinetsGroup) {
      if (sqftFromFeature && sqftFromFeature.cartFeature) {
        //this.changeFeatureIdIfColorWasChanged(sqftFromFeature.cartFeature);
      }
    }
    if (this.shapeParams.isSpacer) {
      this.shapeSpacer = new ShapeSpacer(this);
    }

    // Update layout types can be removed in future
    if (this.shapeParams.layout) {
      switch (this.shapeParams.layout) {
        case SHAPE_LAYOUTS.lowerLayoutType1:
          this.shapeParams.layout = SHAPE_LAYOUTS.LowerLCorner;
          break;
        case SHAPE_LAYOUTS.lowerLayoutType2:
          this.shapeParams.layout = SHAPE_LAYOUTS.LowerDullangle;
          break;
        case SHAPE_LAYOUTS.lowerLayoutType3:
          this.shapeParams.layout = SHAPE_LAYOUTS.LowerIroningBoard;
          break;
        case SHAPE_LAYOUTS.lowerLayoutType4:
          this.shapeParams.layout = SHAPE_LAYOUTS.LowerDimondShape;
          break;
        case SHAPE_LAYOUTS.lowerLayoutType5:
          this.shapeParams.layout = SHAPE_LAYOUTS.LowerDimondCorner;
          break;
        case SHAPE_LAYOUTS.upperLayoutType2:
          this.shapeParams.layout = SHAPE_LAYOUTS.UpperLCorner;
          break;
        case SHAPE_LAYOUTS.upperLayoutType4:
          this.shapeParams.layout = SHAPE_LAYOUTS.UpperDimondShape;
          break;
        case SHAPE_LAYOUTS.upperLayoutType5:
          this.shapeParams.layout = SHAPE_LAYOUTS.UpperDimondCorner;
          break;
        default:
          // If no match, keep the existing layout
          break;
      }
    }
  };
  this.changeFeatureIdIfColorWasChanged = (newFeature= null) => {
    const relatedParentFeature = this.getRelatedParentFeature();
    const currentShapeFeature = this.getFeature();
    const shouldChangeShapePartId = shouldChangeCabinetShapePartId(relatedParentFeature, newFeature);
    if (shouldChangeShapePartId && newFeature.dbFeature && currentShapeFeature) {
      const newParent = CabinetSwitchers.getNeededFeatureFromNavItems(newFeature.dbFeature.sharedFeatureName, relatedParentFeature.getParent())

      if (newParent && newParent.dbFeature) {
        const featureRelatedFeatures = newParent.getFeatureRelatedFeatures();
        let newShapeDbFeature = null;
        if (Array.isArray(featureRelatedFeatures) && featureRelatedFeatures.length > 0) {
          newShapeDbFeature = getCabinetSimilarFeatureFromAnotherColor(featureRelatedFeatures, currentShapeFeature.dbFeature);
        }
        if (newShapeDbFeature) {
          //if (newShapeDbFeature && newShapeDbFeature.sharedFeatureName !== 'SW-WBC3630') { // this line is only for debugging
          this.setRelatedParentFeatureId(newParent.dbFeature.id);
          this.setFeatureId(newShapeDbFeature.id)
        } else {
          store.dispatch(addShapeIdWithMissingFeature(this.id));
          store.dispatch(setShouldShowChangeShapeFeatureMissingMessage(true));
        }
      }
    }

    return this;
  }
  this.getHoverSegment = function() {
    for (let i = 0; i < shape.length; i++) {
      if (shape[i].isHovering()) {
        return shape[i];
      }
    }
  };
  this.getHoverSegmentV2 = () => {
    for (let i = 0; i < shape.length; i++) {
      shape[i].updateLineHovering(sqftEventManager.getMousePos())
      if (shape[i].isHovering()) {
        return shape[i];
      }
    }
  };
  this.getHoverSegmentOutlineCorner = function() {
    for (let i = 0; i < shape.length; i++) {
      if (shape[i].isAngleHovering()) {
        return shape[i].lineCorner;
      }
    }
  };
  this.getHoverSegmentCorner = function() {
    for (let i = 0; i < shape.length; i++) {
      if (shape[i].isCornerLineHovering()) {
        return shape[i].lineCorner;
      }
    }
  };
  this.getHoverPoint = function() {
    for (var i = 0; i < shape.length; i++) {
      if (shape[i].to.isHovering()) {
        return shape[i].to;
      }
    }
  };
  this.getHoverMiteredPoint = function() {
    for (let i = 0; i < shape.length; i++) {
      if (shape[i].isWithMitered()) {
        for (let point of shape[i].miteredOverlay.getPoints()) {
          if (point.isHovering()) {
            return point;
          }
        }
      }
    }
  };
  this.getHoverLabel = () => {
    for (let i = 0; i < shape.length; i++) {
      if (shape[i].labelOverlay && shape[i].labelOverlay.isHovered()) {
        return shape[i].labelOverlay
      }
    }
  };
  this.getHoverPointOnClick = function() {
    for (var i = 0; i < shape.length; i++) {
      if (shape[i].to.isOverPointField()) {
        return shape[i].to;
      }
    }
  };
  this.getCenter = () => {
    if (!this.staticCenterPoint) {
      let points = this.getPoints();

      this.staticCenterPoint = ShapeHelper.getCenterPoint(points);
    }
    return this.staticCenterPoint;
  }
  /**
   * Note changing this value can break display in slabMode
   * @param value
   */
  this.setCenter = (value) => {
    this.staticCenterPoint = value;
  }
  this.getLines = (shouldIncludeBumpoutLines = false) => {
    if (shouldIncludeBumpoutLines) {
      const linesWithBumpouts = [];
      shape.forEach(line => {
        if (line.isWithBumpout()) {
          linesWithBumpouts.push(...line.bumpoutOverlay.getBumpoutLines())
        } else {
          linesWithBumpouts.push(line);
        }
      });
      return linesWithBumpouts
    }

    return shape;
  };
  this.createLinesWithoutAngle = () => {
    this.linesWithoutAngle = getLinesWithoutAnglePoints(this.getLines());
    return this.linesWithoutAngle
  }
  this.getLinesWithoutAngle = () => {
    return this.linesWithoutAngle
  }
  this.getLineCorners = function() {
    const lineCorners = [];
    shape.forEach(line => {
      if (line.lineCorner !== undefined)
        lineCorners.push(line.lineCorner)
    });
    return lineCorners
  };
  this.getPoints = () => {
    return this.getLines().map(line => line.from);
  };
  this.getPointsCoords = () => {
    return getPointsCoordsFromShape(this);
  };
  this.setOriginalPointsCoords = (value) => {
    this.originalPointsCoords = value;
  };
  this.getOriginalPointsCoords = () => {
    return this.originalPointsCoords;
  };
  this.getPointsPosOnWorkspace = (shouldGetRegularPosition = false) => {
    return this.getLines().map(line => { return {...line.from.getPointPosOnWorkspace(shouldGetRegularPosition), id: line.from.id}});
  };
  this.getBumpoutPointsPosOnWorkspace = () => {
    let bumpoutPointsOnWorkspace = [];
    this.getLines().forEach(line => {
      if (line.isWithBumpout()) {
        const bumpoutPoints = line.bumpoutOverlay.getBumpoutPoints();
        for (const pointName in bumpoutPoints) {
          if (bumpoutPoints.hasOwnProperty(pointName)) {
            bumpoutPointsOnWorkspace.push(bumpoutPoints[pointName].getPointPosOnWorkspace());
          }
        }
      }
    });
    return bumpoutPointsOnWorkspace
  };
  this.getPointsPointField = () => {
    return this.getLines().map(line => { return {...getPointField(line.from.x, line.from.y, this), id: line.from.id}});
  };
  this.getOriginPointOnWorkspace = () => {
    // if (shape.shapeParams && shape.shapeParams.shapeLayout !== SHAPE_LAYOUTS.rectangle) {
    //   let realShapeDepth = shapeDepth;
    //   if (shape.shapeParams && SHAPE_SQUARE_LAYOUTS.includes(shape.shapeParams.shapeLayout)) {
    //     realShapeDepth = shapeWidth;
    //   }
    //   zeroPointPosOnWorkspace = CabinetsSet.getShapeCorrectedPos(shape.rotatedDegrees, shapePosition, shapeWidth, realShapeDepth);
    // }

    // Here we will return intersection between first and last lines
    if (this.shapeParams && SHAPE_DIAMOND_LAYOUTS.includes(this.shapeParams.shapeLayout)) {
      const pointsOnWorkspace = this.getPointsPosOnWorkspace();
      const intersection = getIntersectCordsBetweenLines(pointsOnWorkspace[1], pointsOnWorkspace[0], pointsOnWorkspace[pointsOnWorkspace.length - 2], pointsOnWorkspace[pointsOnWorkspace.length - 1], true ,true);
      if (intersection) {
        return intersection
      }
    }

    return this.getPoints()[0].getPointPosOnWorkspace();
  }
  this.getLineById = function(id) {
    return this.getLines().find((line) => line.id === id);
  };
  this.getTotalArea = () => {
    let totalArea,
      anglesTotalArea;

    if (CABINET_BOXES.includes(this.partId)) {
      return 0
    }

    //shape area
    totalArea = sqftConfig.measureUnit === "Imperial" ? this.getTotalInches() : this.getTotalMillimeters();
    //shape corners area
    totalArea += sqftConfig.measureUnit === "Imperial" ? this.getCornersArea() : sqInchesToMM2(this.getCornersArea());

    //console.log("countertop", totalArea);
    //additional bumpout area
    totalArea += this.getBumpoutTotalArea();

    //additional angles area
    anglesTotalArea = this.getAnglesTotalArea();
    totalArea += sqftConfig.measureUnit === "Imperial" ? anglesTotalArea : sqInchesToMM2(anglesTotalArea);

    //additional edges waterfall area
    totalArea += this.getEdgesAdditionalArea();
    //console.log("edges", this.getEdgesAdditionalArea());
    //additional edges waterfall area
    totalArea += this.getWaterfallToolAdditionalArea();

    //additional mitered area
    totalArea += this.getMiteredTotalArea();

    //console.log("mitered", this.getMiteredTotalArea());
    //console.log("total", totalArea);

    return totalArea;
  };

  this.getTotalVolume = () => {
    const totalVolume = this.getTotalInches() * this.getDepth(true);
    return sqftConfig.measureUnit === "Imperial" ? totalVolume : sqInchesToMM2(totalVolume);
  };

  /**
   * Starting and ending lines
   */
  this.getSideLines = () => {
    const lines = this.getLines()
    switch (this.shapeType) {
      case "wideangle":
        return [lines[1], lines[4]];
      case "horseshoe":
        return [lines[2], lines[6]];
      default:
        break;
    }
  }

  this.getCornersArea = () => {
    const points = this.getPoints();
    let cornersAdditionalArea = 0;

    function getRectangle(basePoint1, basePoint2, width) {
      const direction = {
        x: basePoint2.x - basePoint1.x,
        y: basePoint2.y - basePoint1.y,
      };

      const length = Math.sqrt(direction.x ** 2 + direction.y ** 2);
      const norm = {
        x: -direction.y / length,
        y: direction.x / length,
      };

      const rect = [
        [basePoint1.x + norm.x * width / 2, basePoint1.y + norm.y * width / 2],
        [basePoint1.x - norm.x * width / 2, basePoint1.y - norm.y * width / 2],
        [basePoint2.x - norm.x * width / 2, basePoint2.y - norm.y * width / 2],
        [basePoint2.x + norm.x * width / 2, basePoint2.y + norm.y * width / 2],
        [basePoint1.x + norm.x * width / 2, basePoint1.y + norm.y * width / 2],
      ];

      return [rect];
    }

    for (let i = 0; i < points.length; i++) {
      const prev = points[(i - 1 + points.length) % points.length];
      const current = points[i];
      const next = points[(i + 1) % points.length];

      const angle = getAngleBetween3Points(prev, current, next); // Угол между точками
      //const distancePrev = getPointDistance(prev, current); // Длина стороны (base)
      //const distanceNext = getPointDistance(current, next); // Длина другой стороны

      if (Math.round(angle) !== 0 && (Math.round(angle) > 92 || Math.round(angle) < 88)) {
        const RECT_WIDTH = 52; //todo get shape width
        //console.log("distancePrev", distancePrev);
        //console.log("distanceNext", distanceNext);
        const rect1 = getRectangle(prev, current, RECT_WIDTH);
        const rect2 = getRectangle(current, next, RECT_WIDTH);
        let intersection;
        try {
          intersection = polygonClipping.intersection([rect1], [rect2]);
        } catch (e) {
          void e;
        }

        if (intersection && intersection.length > 0) {
          let totalArea = 0;
          intersection.forEach((polygon) => {
            totalArea += calculatePolygonClippingPolygonArea(polygon);
          });

          cornersAdditionalArea += totalArea;
          //console.log("Area of intersection:", totalArea);
        } else {
          console.log("No intersection found");
        }
      }
    }

    return cornersAdditionalArea;
  };

  this.getTotalLnft = function() {
    return Math.ceil(inchesToLNFT(this.getTotalArea())) ;
  };

  this.getAttachedEdges = function() {
    const reduxState = store.getState();
    return reduxState.sqftResourceState.attachedToLine.filter(attachedToLine => {
      return shape.some(line => attachedToLine.attachedToId === line.id)
    });
  };

  this.getWaterfallToolAdditionalArea = () => {
    let totalArea = 0;
    const lines = this.getLines();
    lines.forEach(line => {
      if (line.isWithWaterfallToolEdge && (line.isWithWaterfallToolEdge() || line.isWithPeninsulaUnderwrapEdge())) {
        const waterfallOverlay = workspaceControllers.waterfall.getResourceByLineId(line.id);
        if (waterfallOverlay) {
          totalArea += waterfallOverlay.getArea();
        }
      }
    });

    return totalArea
  }

  this.getEdgesAdditionalArea = () => {
    let totalArea = 0;
    //let edges = sqftStore.getShapeType('edge');
    const edges = this.getAttachedEdges();
    edges.forEach(edge => {
      const line = workspace.getLineById(edge.attachedToId);
      const lineLength = config.measureUnit === "Imperial" ? line.getLineLength() : line.getLineLengthMm();
      totalArea += getEdgeArea(line, lineLength, edge.featureId);
    });

    return totalArea;
  };

  this.getAnglesTotalArea = () => {
    let totalArea = 0;
    let innerPoints = ShapeHelper.getInnerCornerPoints(this);
    innerPoints.forEach(point => {
      if (point.angle) {
        totalArea += (point.angle * point.angle / 2) * 2
      } else if (point.arcLength) {
        totalArea += (point.arcLength * point.arcLength / 2) * 2
      }
    });

    return totalArea
  };

  this.getBumpoutTotalArea = () => {
    let area = 0;
    shape.forEach((line) => {
      if (line.isWithBumpout() && line.bumpoutOverlay) {
        area += config.measureUnit === "Imperial"
          ? line.bumpoutOverlay.getBumpoutTotalArea().inches
          : line.bumpoutOverlay.getBumpoutTotalArea().millimeters;
      }
    });

    return area
  };

  this.getMiteredTotalArea = () => {
    let totalArea = 0;
    shape.forEach(line => {
      if (line.isWithMitered() && line.miteredOverlay) {
        totalArea += line.miteredOverlay.getMiteredTotalArea();
      }
    });

    return totalArea
  };

  this.getTotalInches = function() {
    var inchesCount = 0;
    // square1 = 0,
    // square2 = 0,
    // square3 = 0;
    // console.log('self.shapeType', self.shapeType);
    // console.log('shape', shape);
    // todo remove ifs
    if (self.shapeType === 'square') {
      // inchesCount = ((this.rotatedDegrees === 90) || (this.rotatedDegrees === 270))
      //   ? shape[1].getLineLength() * shape[2].getLineLength()
      //   : shape[0].getLineLength() * shape[1].getLineLength();

      inchesCount = this.getAreaByShoelaceFormula();
    } else if (self.shapeType === 'wideangle') {
      // square1 = (shape[0].getLineLength() - shape[4].getLineLength()) * shape[1].getLineLength();
      // square2 = shape[4].getLineLength() * shape[5].getLineLength();
      // inchesCount = square1 + square2

      inchesCount = this.getAreaByShoelaceFormula();
    } else if (self.shapeType === 'horseshoe') {
      // square1 = shape[4].getLineLength() * (shape[7].getLineLength() - shape[5].getLineLength());
      // square2 = shape[2].getLineLength() * shape[1].getLineLength();
      // square3 = shape[6].getLineLength() * shape[7].getLineLength();
      // inchesCount = square1 + square2 + square3
      inchesCount = this.getAreaByShoelaceFormula();
    } else {
      inchesCount = this.getAreaByShoelaceFormula();
    }

    return inchesCount;
  };

  this.getAreaByShoelaceFormula = function () {
    return getAreaByShoelaceFormula(shape);
  };

  this.isWithBumpout = function () {
    return shape.some((line) => {
      return line.isWithBumpout();
    });
  };

  this.isWithMitered = function () {
    return shape.some((line) => {
      return line.isWithMitered();
    });
  };

  this.getTotalMillimeters = function() {
    return sqInchesToMM2(this.getAreaByShoelaceFormula());
  };

  function getRotateAngleRectangle(rotateAnglePart) {
    //line 1
    const line1 = shape[rotateAnglePart.line1];
    let renderFrom = line1.calculateRenderPosition(line1.from);
    let renderTo = line1.calculateRenderPosition(line1.to);
    //line2
    const line2 = shape[rotateAnglePart.line2];
    let renderFrom2 = line2.calculateRenderPosition(line2.from);
    let renderTo2 = line2.calculateRenderPosition(line2.to);
    return [
      [renderFrom.x, renderFrom.y],
      [renderTo.x, renderTo.y],
      [renderFrom2.x, renderFrom2.y],
      [renderTo2.x, renderTo2.y],
    ]
  }

  var handleArrowInputIncrease = (isNegative, input, rotateAnglePart, basePoint, secondaryPoint, rotated90_1, rotated90_2, bottomLine) => {
    if (isNegative) {
      input.value = +input.value + 1;
    } else {
      input.value = +input.value - 1;
    }

    self.rotateAngleInputChange(input, rotateAnglePart, basePoint, secondaryPoint, rotated90_1, rotated90_2, bottomLine);
  };

  const moveShape = (mousePos) => {
    let scale = sqftStore.getScale();
    let xDiff = (state.mouseDownPosition.x - mousePos.x) / scale;
    let yDiff = (state.mouseDownPosition.y - mousePos.y) / scale;

    // mark that user actually moved the shape while mouse is down
    state.wasDragging = true;

    let isShowSlabTool = store.getState().sqftSlabState.isShowSlabTool;
    if (this.shapeParams.canSnap || isShowSlabTool) {
      const shapeAbsolute = isShowSlabTool ? this.shapeSlab.shapeAbsolute : this.shapeAbsolute;
      workspaceControllers.snappedShapeGroups.resetShapeSnappedGroup(shapeAbsolute);
      workspaceControllers.snappedShapeGroups.updateShapeSnappedGroup(this, true);
    }

    if (isShowSlabTool) {
      // this.shapeSlab.setAbsolutePos(null);//reset minLength for correct calculations without stacking
      // let distancesToShapes = ShapeHelper.getDistancesToShapes(this);
      // let distancesToImages = ShapeHelper.getDistancesToSlabImages(this);
      // //console.log("distancesToImages", distancesToImages);
      //
      // snapPossibilitiesToShapes = ShapeHelper.getSnappingPossibilities(distancesToShapes);
      // snapPossibilitiesToImages = ShapeHelper.getSnappingPossibilities(distancesToImages);
      //
      // this.setAbsolutePosFromSnapPossibilities(snapPossibilitiesToShapes);
      // this.setAbsolutePosFromSnapPossibilities(snapPossibilitiesToImages);

      this.slabPos.x -= xDiff;
      this.slabPos.y -= yDiff;
    } else {
      // this.pos.x -= xDiff;
      // this.pos.y -= yDiff;
      this.setPosition({
        x: this.pos.x - xDiff,
        y: this.pos.y - yDiff,
      })
    }

    state.mouseDownPosition.x = mousePos.x;
    state.mouseDownPosition.y = mousePos.y;
    // console.log('self.pos', self.pos);
  };

  this.setAbsolutePosFromSnapPossibilities = (snapPossibilities) => {
    if (snapPossibilities.length > 0) {
      let scale = sqftStore.getScale();
      let absolutePos = {...this.slabPos};
      snapPossibilities.forEach((snap) => {
        switch (snap.orientation) {
          case "horizontal":
            absolutePos.y -= snap.diff / scale
            break;
          case "vertical":
            absolutePos.x -= snap.diff / scale
            break;
        }
        this.shapeSlab.setAbsolutePos(absolutePos)
      })
    }
  }

  const isMouseOverShape = (mousePos) => {
    const scale = sqftStore.getScale(),
      wp = sqftStore.getOffset(),
      pos = self.getPosition(),
      offset = {
        x: mousePos.x - (pos.x * scale) - wp.x,
        y: mousePos.y - (pos.y * scale) - wp.y
      },
      vertx = [],
      verty = [],
      vert2x = [],
      vert2y = [];

    for (var i = 0; i < shape.length; i++) {
      const isSlabMode = SqftStore.isSlabMode();
      if (shape[i].isHovering(isSlabMode) && !isSlabMode //exclude hovering lines in the slab mode
        || shape[i].isAngleHovering()
        || shape[i].isCornerLineHovering()
      ) {
        setHoveringOnlyShape(false);

        return setHovering(true);
      }
      var pointDirection  = shape[i].from.getPointDirection();
      let pointFromX = shape[i].from.x
      let pointFromY = shape[i].from.y

      switch (pointDirection) {
        case "lefttop":
          vertx.push(pointFromX * scale - marginFromShape);
          verty.push(pointFromY * scale - marginFromShape);
          break;
        case "righttop":
          vertx.push(pointFromX * scale + marginFromShape);
          verty.push(pointFromY * scale - marginFromShape);
          break;
        case "rightbottom":
          vertx.push(pointFromX * scale + marginFromShape);
          verty.push(pointFromY * scale + marginFromShape);
          break;
        case "leftbottom":
          vertx.push(pointFromX * scale - marginFromShape);
          verty.push(pointFromY * scale + marginFromShape);
          break;
        default:
          vertx.push(pointFromX * scale);
          verty.push(pointFromY * scale);
          break;
      }
      vert2x.push(pointFromX * scale);
      vert2y.push(pointFromY * scale);
    }
    var prevState = self.isHovering();

    let isHovering = pnpoly(shape.length, vertx, verty, offset.x, offset.y);
    setHovering(isHovering);
    setHoveringOnlyShape(pnpoly(shape.length, vert2x, vert2y, offset.x, offset.y));
    self.rotateAngleParts.forEach((rotateAnglePart) => {
      if ((self.shapeType === "wideangle")
        && !rotateAnglePart.rotatedAngleValue
        && self.rotateAngleParts.some(rotPart => rotPart.rotatedAngleValue > 0)) {
        rotateAnglePart.isHovered = false;  // L shape may have only 1 part rotated
      } else {
        rotateAnglePart.isHovered = pnpolyArray(getRotateAngleRectangle(rotateAnglePart), mousePos);
      }
    });
    if (prevState && !self.isHovering()) {
      sqftEventManager.resetCursor(self);
    }
    return this.isHovering();
  };

  //private event handlers
  const onMouseMove = (mousePos, e) => {
    if (e.terminate && !state.mouseDown) {
      setHoveringOnlyShape(false);
      return setHovering(false);
    }
    if (isMouseOverShape(mousePos)) {
      //console.log("shape id", this.id);
      if (self.onHover) {
        self.onHover(self);
      }
      // todo fix bumpout rotation and remove this
      if (sqftConfig.workspace.menuItemActive === "rotate-left") {
        //sqftEventManager.setCursor("rotate-left", self);
        if (self.isWithBumpout() || self.isWithMitered()) {
          sqftEventManager.stealCursor(true);
          sqftEventManager.setCursor("deny", self);
        }
      }
      if (state.mouseDown && !sqftStore.getAllowEdges()) {
        sqftEventManager.setCursor('move', self, true);
        //todo
        //console.log("state.mouseDown", state.mouseDown);
        moveShape(mousePos);
        hideShapeOffsetInTheSlabMode();
      } else if (!sqftStore.getAllowEdges()) {
        sqftEventManager.setCursor('move', self)
      }
      return state.mouseDown;
    }
    //smooth scrolling
    if (state.mouseDown && !sqftStore.getAllowEdges()) {
      sqftEventManager.setCursor('move', self, true);
      moveShape(mousePos);
    }
    // //smooth scrolling
    // if (state.mouseDown && !sqftStore.getAllowEdges()) {
    //   sqftEventManager.setCursor('move', self, true);
    //   moveShape(mousePos);
    //   console.log("333",);
    // }
    // //smooth scrolling
    // if (state.mouseDown && !sqftStore.getAllowEdges()) {
    //   sqftEventManager.setCursor('move', self, true);
    //   moveShape(mousePos);
    // }
    sqftEventManager.resetCursor(self);
    return false;
  }
  const onDblClick = (mousePos, e) => {
    void mousePos; void e;
    // if (state.hovering) {
    //   this.setIsPointsMovable(!state.isPointsMovable);
    // }
  }
  const onContextmenu = (mousePos, e) => {
    void mousePos;
    void e;
    if (state.hovering) {
      const reduxState = store.getState();
      const {sqftActiveShapeId} = reduxState.sqftMenuState;
      if (sqftActiveShapeId !== this.id) {
        store.dispatch(setSQFTActiveShapeId(null));
      }
      setTimeout(() => {
        store.dispatch(setSQFTActiveShapeId(this.id))
      }, [300]);

      return true
    }
  }
  const onMouseUp = (mousePos, e) => {
    void mousePos;
    void e;
    //debugger // eslint-disable-line no-debugger
    sqftEventManager.releaseStealLock(this);
    this.setIsPointsMovable(false);
    this.preventNegativeArea();
    if (this.isHovering()) {
      restoreShapeOffsetInTheSlabMode();

      //Update slab features
      const slabPlaceHolderShapes = sqftSlabManager.getSlabPlaceHolderShapes();
      const slabImages = sqftImageManager.getSlabImages();
      if (slabImages.length || slabPlaceHolderShapes.length) {
        sqftShapeIntersectionsManager.updateShapesIntersections();
        this.shapeIntersections.handleSlabPlaceholderAndSlabImageIntersections();
        if (this.partId !== SHAPE_PART_ID.slabPlaceHolder) {
          // Changed countertop must set feature for the slab/placeholder placed on it.
          sqftShapeIntersectionsManager.syncSlabFeaturesFromCountertopShape(this.id);
        }
      }

      if (state.mouseDown) {
        this.shapeAutoShuffle.handlePlaceShapeOnTheLine();
      }

      /** Context menu for mobile  */
      const reduxState = store.getState();
      const activeButton = reduxState.sqftMenuState.activeButton;

      const isMobile = store.getState().serverState.isMobile || isIOSDeviceV2();
      if (isMobile && !state.wasDragging && activeButton === SIDEBAR_BUTTONS_MENU.move) {
        onContextmenu();
      }
    }
    state.mouseDown = false;
    state.mouseDownPosition = null;
    state.wasDragging = false;
  }

  const onMouseDown = (mousePos, e) => {
    void e;
    //if not then handle event with this object
    if (this.isHovering()) {
      // remove or add shape to selection
      if (e.shiftKey) {
        if (workspaceControllers.selectedShapes.isShapeSelected(this)) {
          workspaceControllers.selectedShapes.removeShapeFromSelection(this);
        } else {
          workspaceControllers.selectedShapes.addShapeToSelection(this);
        }
      }
      this.shapeMemory.rememberShapePosition();
      setShapeToShapeOffset();
      if (sqftEventManager.getCursor().indexOf("move") >= 0) {
        state.mouseDown = true;
        state.mouseDownPosition = mousePos;
      }
      if (sqftConfig.highlight.rotateAngle) {
        // todo fix bumpout rotation and remove this
        if (self.isWithBumpout() || self.isWithMitered() || this.isPointsMoved || this.rotatedDegrees !== 0) {
          return
        }
        /////////////////////////////////////////

        self.rotateAngleParts.forEach((rotateAnglePart) => {
          if (rotateAnglePart.isHovered) {
            //todo
            self.setRotateAnglePartActive(rotateAnglePart);
          } else {
            rotateAnglePart.isActive = false;
          }
        });
        if (!self.rotateAngleParts.some(rotateAnglePart => rotateAnglePart.isActive)) {
          self.deActivateRotateAngle();
        }
      }

      if (this.partId !== SHAPE_PART_ID.slabPlaceHolder) { // seam not allowed to be added on slab placeholders
        const reduxState = store.getState();
        const activeButton = reduxState.sqftMenuState.activeButton;
        if (activeButton === SIDEBAR_SLAB_SEAM_BUTTONS.addSeamVertical) {
          this.shapeSlab.addSeamPieceVertical(mousePos);
          this.setIsPointsChanged(false); //prevent creating new backSplash shape if it was seamed
        } else if (activeButton === SIDEBAR_SLAB_SEAM_BUTTONS.addSeamHorizontal) {
          this.shapeSlab.addSeamPieceHorizontal(mousePos);
          this.setIsPointsChanged(false); //prevent creating new backSplash shape if it was seamed
        }
      }

      /** Split shape into two parts if two freeSeam points was added **/
      const isSlabMode = SqftStore.isSlabMode();
      if (isSlabMode && this.seamCutPointsAndLines.length >= 2) {
        this.shapeSlab.addFreeSeam();
        const hoveredShape = workspace.getHoveredSqftShape(true);
        if (hoveredShape) {
          hoveredShape.updateMouseDown(mousePos);
          sqftSlabManager.initShapeOffset(hoveredShape);
        }
        this.setIsPointsChanged(false); //prevent creating new backSplash shape if it was seamed
      }

      return true;
    }
    return false;
  }

  const hideShapeOffsetInTheSlabMode = () => {
    if (SqftStore.isSlabMode()) {
      const slabShapeOffset = SlabWorkspace.getShapeOffset();
      if (slabShapeOffset) {
        slabShapeOffset.hide();
      }
    }
  }

  const restoreShapeOffsetInTheSlabMode = () => {
    if (SqftStore.isSlabMode()) {
      const slabShapeOffset = SlabWorkspace.getShapeOffset();
      if (slabShapeOffset) {
        slabShapeOffset.restore();
      }
    }
  }

  const setShapeToShapeOffset = () => {
    const isSlabMode = SqftStore.isSlabMode();

    if (isSlabMode && this.partId !== SHAPE_PART_ID.slabPlaceHolder) {
      sqftSlabManager.initShapeOffset(this);
    }
  }

  function hideAngleTooltip() {
    const angleTooltip = document.getElementById("angle-tooltip");
    const inputArrows = [].slice.call(document.querySelectorAll("#angle-tooltip [data-action]"));
    // const inputSubmit = document.querySelectorAll('[data-action="angle-input-submit"]');

    if (angleTooltip) {
      angleTooltip.style.display = "none";
      //remove event handlers
      inputArrows.forEach(function (elem) {
        elem.parentNode.replaceChild(elem.cloneNode(true), elem);
      });
      // inputSubmit[0].removeEventListener('click', self.deActivateRotateAngle);
    }
  }

  function hideAngleTooltipArrows (value) {
    const angleTooltip = document.getElementById("angle-tooltip");
    const inputArrowUp = [].slice.call(angleTooltip.querySelectorAll('[data-action="angle-input-up"]'));
    const inputArrowDown = [].slice.call(angleTooltip.querySelectorAll('[data-action="angle-input-down"]'));

    inputArrowUp.forEach((button) => {
      if (value === minAngle) {
        button.style.display = "none";
        clearInterval(state.handlerHold);
      } else {
        button.style.display = "block";
      }
    });
    inputArrowDown.forEach((button) => {
      if (value === maxAngle) {
        button.style.display = "none";
        clearInterval(state.handlerHold);
      } else {
        button.style.display = "block";
      }
    });
  }
  //public functions

  /**
   *  return array of getPointField for each point
   */
  this.getPointFieldArray = () => {
    let pointsArray = []
    for (const line of shape) {
      pointsArray.push(getPointField(line.from.x, line.from.y, line));
    }
    return pointsArray
  }
  this.preventNegativeArea = () => {
    if (this.getTotalArea() < 0) {
      this.reversePoints();
      const state = store.getState();
      const updateCalculations = state.sqftState.updateCalculations;

      store.dispatch(updateSQFTCalculations(updateCalculations + 1));
    }
  }
  this.reversePoints = () => {
    const reversedPoints = this.getPointCordsArray().reverse();
    shape.forEach((line, lineIndex) => {
      line.from.setPos({
        x: reversedPoints[lineIndex].x,
        y: reversedPoints[lineIndex].y
      });
      line.from.setPosSlab({
        x: reversedPoints[lineIndex].x,
        y: reversedPoints[lineIndex].y
      });
    });
  }
  this.getPointCordsArray = () => {
    let pointsArray = []
    for (const line of shape) {
      pointsArray.push({x: line.from.x, y: line.from.y});
    }
    return pointsArray
  }
  this.activateRotateAngle = function () {
    shape.forEach((line, lineIndex) => {
      for (const rotateAnglePart of self.rotateAngleParts) {
        if (this.isAngleRotatedPartsWithCorner(rotateAnglePart)) {
          continue;
        }
        if (lineIndex === rotateAnglePart.line1) {
          const parentPoint = (rotateAnglePart && rotateAnglePart.angleDirection === "right") ? line.from : line.to;
          parentPoint.renderAngleCircle = 18
        } else if (lineIndex === rotateAnglePart.line2) {
          const secondaryPoint = (rotateAnglePart && rotateAnglePart.angleDirection === "right") ? line.to : line.from;
          secondaryPoint.renderAngleCircle = 12;
        }
        // if (lineIndex === 1) { // this is rendering green arc
        // line.from.renderAngleArc = line.calculateRenderPosition(line.to).y - line.calculateRenderPosition(line.from).y;
        // }
      }
    })
  };
  this.deActivateRotateAngle = function() {
    self.rotateAngleParts.forEach((rotateAnglePart) => {
      rotateAnglePart.isActive = false;
      rotateAnglePart.isHovered = false;
    });

    hideAngleTooltip();
  };
  this.setRotateAnglePartActive = function (rotateAnglePart) {
    hideAngleTooltip(); // 1) deactivate previous anglePart
    rotateAnglePart.isActive = true; // 1) always highlight
    const angleTooltip = document.getElementById("angle-tooltip");
    const input = document.getElementById("angle_input");
    const inputArrowUp = [].slice.call(angleTooltip.querySelectorAll('[data-action="angle-input-up"]'));
    const inputArrowDown = [].slice.call(angleTooltip.querySelectorAll('[data-action="angle-input-down"]'));
    const inputArrows = inputArrowUp.concat(inputArrowDown);
    const inputSubmit = [].slice.call(angleTooltip.querySelectorAll("[data-action=\"angle-input-submit\"]"));

    if (this.isAngleRotatedPartsWithCorner(rotateAnglePart)) {
      return;
    }
    input.setAttribute("min", minAngle.toString());
    input.setAttribute("max", maxAngle.toString());
    angleTooltip.style.display = "flex"; // 2) show input in sidebar

    // 3) set input value to current angle
    input.value = 90 - rotateAnglePart.rotatedAngleValue; // 90 - is made for displaying 90-0-90 rotation deg for input

    // input.value = getAngleValue(rotateAnglePart.rotatedAngleValue); // 3) set input value to current angle
    input.max = (rotateAnglePart && rotateAnglePart.shapeType === "wideangle" && rotateAnglePart && rotateAnglePart.angleDirection === "right") ? 90 : maxAngle; // 3.5 set input max
    input.min = (rotateAnglePart && rotateAnglePart.shapeType === "wideangle" && rotateAnglePart && rotateAnglePart.angleDirection === "right") ? 1 : minAngle; // 3.5 set input max
    hideAngleTooltipArrows(+input.value);

    setTimeout(() => {
      const expandedSidebar = document.querySelector(".side.expanded");
      if (expandedSidebar) {
        $(expandedSidebar).animate({scrollTop: $(expandedSidebar).height()}, 600); // 4) scroll to added input
      }
    }, 600);

    // 4) declare base points and bottom(moving) line
    const basePoint = (rotateAnglePart && rotateAnglePart.angleDirection === "right") ? shape[rotateAnglePart.line1].from : shape[rotateAnglePart.line1].to;
    const secondaryPoint = (rotateAnglePart && rotateAnglePart.angleDirection === "right") ? shape[rotateAnglePart.line2].to : shape[rotateAnglePart.line2].from;
    const bottomLine = (rotateAnglePart && rotateAnglePart.angleDirection === "right") ? shape[rotateAnglePart.line1 + 1] : shape[rotateAnglePart.line1 - 1];
    const secondaryLineLength = shape[rotateAnglePart.line2].getLineLength();
    //const nextLine = self.getNextLine(basePoint.getParent());
    var rotated90_1, rotated90_2;

    switch (rotateAnglePart.shapeType) {
      default:
      case "wideangle":
      case "horseshoe": {
        if (rotateAnglePart && rotateAnglePart.angleDirection === "right") {
          //console.log('RIGHT 90 Orient', bottomLine.getOrientation());
          //console.log('RIGHT newDirection', bottomLine.getLineDirection().newDirection);

          if (bottomLine.getLineDirection().newDirection === 'east') {
            rotated90_1 = {x: secondaryPoint.x - secondaryLineLength, y: basePoint.y};
            rotated90_2 = {x: secondaryPoint.x - secondaryLineLength, y: secondaryPoint.y};
          } else if (bottomLine.getLineDirection().newDirection === 'west') {
            rotated90_1 = {x: secondaryPoint.x + secondaryLineLength, y: basePoint.y};
            rotated90_2 = {x: secondaryPoint.x + secondaryLineLength, y: secondaryPoint.y};
          } else if (bottomLine.getLineDirection().newDirection === 'south') {
            rotated90_1 = {x: basePoint.x, y: secondaryPoint.y - secondaryLineLength};
            rotated90_2 = {x: secondaryPoint.x, y: secondaryPoint.y - secondaryLineLength};
          } else if (bottomLine.getLineDirection().newDirection === 'north') {
            rotated90_1 = {x: basePoint.x, y: secondaryPoint.y + secondaryLineLength};
            rotated90_2 = {x: secondaryPoint.x, y: secondaryPoint.y + secondaryLineLength};
          }

        } else {
          //console.log('LEFT 90 Orient', bottomLine.getOrientation());
          //console.log('LEFT newDirection', bottomLine.getLineDirection().newDirection);

          if (bottomLine.getLineDirection().newDirection === 'east') {
            rotated90_1 = {x: secondaryPoint.x + secondaryLineLength, y: secondaryPoint.y};
            rotated90_2 = {x: secondaryPoint.x + secondaryLineLength, y: basePoint.y};
          } else if (bottomLine.getLineDirection().newDirection === 'west') {
            rotated90_1 = {x: secondaryPoint.x - secondaryLineLength, y: secondaryPoint.y};
            rotated90_2 = {x: secondaryPoint.x - secondaryLineLength, y: basePoint.y};
          } else if (bottomLine.getLineDirection().newDirection === 'south') {
            rotated90_1 = {x: secondaryPoint.x, y: secondaryPoint.y + secondaryLineLength};
            rotated90_2 = {x: basePoint.x, y: secondaryPoint.y + secondaryLineLength};
          } else if (bottomLine.getLineDirection().newDirection === 'north') {
            rotated90_1 = {x: secondaryPoint.x, y: secondaryPoint.y - secondaryLineLength};
            rotated90_2 = {x: basePoint.x, y: secondaryPoint.y - secondaryLineLength};
          }
        }
        break;
      }
    }

    angleTooltip.style.left = basePoint.getPointField().x + "px";
    angleTooltip.style.top = basePoint.getPointField().y + "px";
    const ENTER_KEY = 13;
    // 5) set input handlers and focus it
    input.oninput = () => self.rotateAngleInputChange(input, rotateAnglePart, basePoint, secondaryPoint, rotated90_1, rotated90_2, bottomLine);
    input.focus();
    input.onkeydown = function(e) {
      if (e.keyCode === ENTER_KEY) {
        e.target.blur();
      }
    };
    function blur(e) {
      if (!$(e.target).closest('.ui-input')) {
        input.blur();
      }
    }
    input.onblur = function () {
      // window.lineInputFocused = false;
      // input.parentNode.removeChild(input);
      // document.removeEventListener("click", blur);
    };

    // 6) set input up down and submit handlers
    let holdStarter;// This timeout, started on mousedown, triggers the beginning of a hold
    let holdDelay = 300; // This is how many milliseconds to wait before recognizing a hold
    let holdActive = false; // This flag indicates the user is currently holding the mouse down
    inputArrows.forEach(function (arrow) {
      let arrowMousedown = (e) => {
        e.stopPropagation();
        e.preventDefault();
        const isNegative = e.currentTarget.dataset.action === 'angle-input-down';

        holdStarter = setTimeout(function () {
          holdStarter = null;
          holdActive = true;

          state.handlerHold = setInterval(function () {
            if (holdActive) {
              handleArrowInputIncrease(isNegative, input, rotateAnglePart, basePoint, secondaryPoint, rotated90_1, rotated90_2, bottomLine);
            }
          }, 50);
          //console.log('Holding...')
        }, holdDelay);
      }
      let arrowMouseup = (e) => {
        if (holdStarter) {
          clearTimeout(holdStarter);

          const isNegative = e.currentTarget.dataset.action === 'angle-input-down';
          handleArrowInputIncrease(isNegative, input, rotateAnglePart, basePoint, secondaryPoint, rotated90_1, rotated90_2, bottomLine);
          //console.log('Clicked')
        }
        // Otherwise, if the mouse was being held, end the hold
        else if (holdActive) {
          holdActive = false;
          clearInterval(state.handlerHold);
        }
      };
      arrow.addEventListener('mousedown', arrowMousedown);
      arrow.addEventListener('mouseup', arrowMouseup);
    });
    inputSubmit[0].addEventListener('click', self.deActivateRotateAngle);

    setTimeout(() => {
      document.addEventListener("click", blur);
    }, 500);
  };
  this.removeBumpouts = function () {
    for (var i = 0; i < shape.length; i++) {
      if (shape[i].bumpoutOverlay) {
        shape[i].deleteBumpout();
      }
    }
  };

  /**
   * remember base configuration before rotation (we will need it in onchange method, and after blur)
   **/
  this.setRotateAnglePartBaseConfiguration = (rotateAnglePart, basePoint, secondaryPoint, rotated90_1, rotated90_2, bottomLine) => {
    rotateAnglePart.baseConfiguration = {
      basePointX: basePoint.x,
      basePointX2: secondaryPoint.x,
      basePointY: basePoint.y,
      basePointY2: secondaryPoint.y,
      rotated90_1: rotated90_1,
      rotated90_2: rotated90_2,
      baseOldX: bottomLine.from.x,
      baseOldY: bottomLine.from.y,
      baseOldX1: bottomLine.to.x,
      baseOldY1: bottomLine.to.y,
      widthDiff: Math.abs(basePoint.y - secondaryPoint.y), // difference between basePointX and secondaryPointX, we need it to make bottom line straight
    };
  }

  /**
   * bottomLine - far line, rotating around centerPoint
   * basePoint - first point where rotation starts
   * secondaryPoint - second point where rotation starts
   **/
  this.rotateAngleInputChange = (input, rotateAnglePart, basePoint, secondaryPoint, rotated90_1Calc, rotated90_2Calc, bottomLine) => {
    if (!rotateAnglePart.baseConfiguration || rotateAnglePart.rotatedAngleValue === 0) {
      this.setRotateAnglePartBaseConfiguration(rotateAnglePart, basePoint, secondaryPoint, rotated90_1Calc, rotated90_2Calc, bottomLine)
    }

    let {
      basePointX, basePointX2, basePointY, basePointY2, baseOldX, baseOldY, baseOldX1, baseOldY1, widthDiff, rotated90_1, rotated90_2
    } = rotateAnglePart.baseConfiguration;
    if (input.value > +input.max) {
      input.value = +input.max;
    }
    if (input.value < +input.min) {
      input.value = +input.min;
    }

    // 90 - is set for 90-0-90
    let value = 90 - +input.value;

    hideAngleTooltipArrows(+input.value);

    self.rotateAngleParts.forEach((rotateAnglePart) => {
      if (rotateAnglePart.isActive) {
        rotateAnglePart.rotatedAngleValue = value
      }
    });
    const anglePercentage = Math.round(value * 100 / 90 * 100) / 100; // for example, 20deg = 22.2%
    const diffToMinus = Math.round(widthDiff * anglePercentage / 100 * 100) / 100; // for example, 26 * 45 / 100 = 11.7

    const pointToRotate1 = (value < 90) ? {x:baseOldX, y: baseOldY} : rotated90_1;
    const pointToRotate2 = (value < 90) ? {x:baseOldX1, y: baseOldY1} : rotated90_2;
    const angle = getAngle(rotateAnglePart, value);

    let rotationCenterPoint = getRotationCentrePoint(rotateAnglePart, value, bottomLine, basePoint, secondaryPoint);

    //console.log(angle);
    //console.log(rotationCenterPoint);
    //console.log(pointToRotate1);
    let rotated = rotatePoint(pointToRotate1, rotationCenterPoint, angle);
    let rotated2 = rotatePoint(pointToRotate2, rotationCenterPoint, angle);

    bottomLine.from.x = rotated.x;
    bottomLine.from.y = rotated.y;
    bottomLine.to.x = rotated2.x;
    bottomLine.to.y = rotated2.y;

    // change base points positions
    // var tempPoint = new point(rotationCenterPoint.x, rotationCenterPoint.y);
    // tempPoint.init(bottomLine);
    // tempPoint.layout = 'white-circle';

    switch (rotateAnglePart.shapeType) {
      case "wideangle":
      case "horseshoe":
      default: {
        //console.log('diffToMinus', diffToMinus)
        if (diffToMinus < widthDiff) {
          if (rotateAnglePart && rotateAnglePart.angleDirection === "right") {
            //console.log('RIGHT bottom Orient',bottomLine.getOrientation())
            switch (bottomLine.getOrientation()) {
              case orientation.HORIZONTAL: {
                basePoint.x = basePointX; secondaryPoint.x = basePointX2;
                break;
              }
              case orientation.VERTICAL: {
                basePoint.y = basePointY; secondaryPoint.y = basePointY2;
                break;
              }
              case orientation.SOUTHEAST: { basePoint.y = basePointY + diffToMinus; secondaryPoint.y = basePointY2;
                break;
              }
              case orientation.NORTHWEST: { basePoint.y = basePointY - diffToMinus; secondaryPoint.y = basePointY2;
                break;
              }
              case orientation.NORTHEAST: { basePoint.x = basePointX + diffToMinus; secondaryPoint.x = basePointX2;
                break;
              }
              case orientation.SOUTHWEST: { basePoint.x = basePointX - diffToMinus; secondaryPoint.x = basePointX2;
                break;
              }
              default:
                break;
            }
          } else {
            //console.log('LEFT bottom Orient',bottomLine.getOrientation())
            switch (bottomLine.getOrientation()) {
              case orientation.HORIZONTAL: { basePoint.x = basePointX; secondaryPoint.x = basePointX2;
                break;
              }
              case orientation.VERTICAL: { basePoint.y = basePointY; secondaryPoint.y = basePointY2;
                break;
              }
              case orientation.SOUTHEAST: { basePoint.x = basePointX - diffToMinus; secondaryPoint.x = basePointX2;
                break;
              }
              case orientation.NORTHWEST: { basePoint.x = basePointX + diffToMinus; secondaryPoint.x = basePointX2;
                break;
              }
              case orientation.NORTHEAST: { basePoint.y = basePointY + diffToMinus; secondaryPoint.y = basePointY2;
                break;
              }
              case orientation.SOUTHWEST: { basePoint.y = basePointY - diffToMinus; secondaryPoint.y = basePointY2;
                break;
              }
              default:
                break;
            }
          }
          //console.log('basePoint', basePoint);
          //console.log('secondaryPoint', secondaryPoint);
        } else {
          if (rotateAnglePart && rotateAnglePart.angleDirection === "right") {
            //console.log('RIGHT 90 Orient', bottomLine.getOrientation());
            switch (bottomLine.getOrientation()) {
              case orientation.HORIZONTAL:
                if (self.getNextLine(basePoint.getParent()).getLineDirection().orientation === "vertical"){
                  basePoint.x = basePointX - widthDiff;
                  secondaryPoint.x = basePointX2 - widthDiff;
                } else {
                  if (bottomLine.getLineDirection().newDirection === "east"){
                    if (self.getPrevLine(basePoint.getParent()).getLineDirection().orientation === "vertical"){
                      basePoint.x = basePointX;
                      secondaryPoint.x = basePointX2;
                    } else {
                      basePoint.x = basePointX - widthDiff;
                      secondaryPoint.x = basePointX2 + widthDiff;
                    }
                  } else {
                    if (self.getPrevLine(basePoint.getParent()).getLineDirection().orientation === "vertical"){
                      basePoint.x = basePointX;
                      secondaryPoint.x = basePointX2;
                    } else {
                      basePoint.x = basePointX + widthDiff;
                      secondaryPoint.x = basePointX2 - widthDiff;
                    }
                  }
                }
                break;
              case orientation.VERTICAL:
                if (self.getNextLine(basePoint.getParent()).getLineDirection().orientation === "vertical") {
                  if (bottomLine.getLineDirection().newDirection === "north") {
                    if (self.getPrevLine(basePoint.getParent()).getLineDirection().orientation === "horizontal") {
                      basePoint.y = basePointY;
                      secondaryPoint.y = basePointY2;
                    } else {
                      basePoint.y = basePointY + widthDiff;
                      secondaryPoint.y = basePointY2 - widthDiff;
                    }
                  } else {
                    if (self.getPrevLine(basePoint.getParent()).getLineDirection().orientation === "horizontal") {
                      basePoint.y = basePointY ;
                      secondaryPoint.y = basePointY2 ;
                    } else {
                      basePoint.y = basePointY - widthDiff;
                      secondaryPoint.y = basePointY2 + widthDiff;
                    }
                  }
                }
                break;
              case orientation.SOUTHEAST: {
                secondaryPoint.x = basePointX2 - widthDiff + diffToMinus;
                basePoint.x = basePointX - widthDiff;
                break;
              }
              case orientation.NORTHEAST: {
                secondaryPoint.y = basePointY2 + widthDiff - diffToMinus;
                basePoint.y = basePointY + widthDiff;
                break;
              }
              case orientation.SOUTHWEST: {
                secondaryPoint.x = basePointX2;
                basePoint.x = basePointX;
                basePoint.y = basePointY - widthDiff;
                secondaryPoint.y = basePointY2 - widthDiff + diffToMinus;
                break;
              }
              case orientation.NORTHWEST: {
                secondaryPoint.x = basePointX2 + widthDiff - diffToMinus;
                basePoint.x = basePointX + widthDiff;
                break;
              }
              default:
                break;
            }
          } else {
            //console.log('LEFT 90 Orient', bottomLine.getOrientation());
            switch (bottomLine.getOrientation()) {
              case orientation.HORIZONTAL:
                if (self.getNextLine(basePoint.getParent()).getLineDirection().orientation === "vertical"){
                  if (bottomLine.getLineDirection().newDirection === "west"){
                    basePoint.x = basePointX - widthDiff;
                    secondaryPoint.x = basePointX2 + widthDiff;
                  } else {
                    basePoint.x = basePointX + widthDiff;
                    secondaryPoint.x = basePointX2 - widthDiff;
                  }
                } else {
                  basePoint.x = basePointX;
                  secondaryPoint.x = basePointX2;
                }
                break;
              case orientation.VERTICAL:
                if (self.getNextLine(basePoint.getParent()).getLineDirection().orientation === "horizontal"){
                  if (bottomLine.getLineDirection().newDirection === "south") {
                    basePoint.y = basePointY + widthDiff;
                    secondaryPoint.y = basePointY2 - widthDiff;
                  } else {
                    basePoint.y = basePointY - widthDiff;
                    secondaryPoint.y = basePointY2 + widthDiff;
                  }
                }
                break;
              case orientation.SOUTHEAST: {
                basePoint.y = basePointY + widthDiff;
                secondaryPoint.y = basePointY2 + widthDiff - diffToMinus;
                break;
              }
              case orientation.NORTHEAST: {
                secondaryPoint.x = basePointX2 + widthDiff - diffToMinus;
                basePoint.x = basePointX + widthDiff;
                break;
              }
              case orientation.SOUTHWEST: {
                basePoint.x = basePointX - widthDiff ;
                secondaryPoint.x = basePointX2 - widthDiff + diffToMinus;
                break;
              }
              case orientation.NORTHWEST: {
                basePoint.y = basePointY - widthDiff;
                secondaryPoint.y = basePointY2 - widthDiff+ diffToMinus;
                break;
              }
              default:
                break;
            }
          }
        }
      }
    }
    // const pointDiff = Math.round(15 * anglePercentage) / 100; // points margin
    [basePoint, secondaryPoint].forEach(point => {
      if (point.arcLength || point.angle) {
        point.arcLength = 0;
        point.angle = 0;
      }
      // disallow points radiuses
      point.angleIsChanged = !!value; // keep if false when angle is 0
      point.rotateAnglePart = rotateAnglePart; // each point has a link on the whole rotated part
    });
    bottomLine.from.rotateAnglePart = rotateAnglePart;
    bottomLine.to.rotateAnglePart = rotateAnglePart;
    // bottomLine.from.pointDiff = pointDiff;
    // bottomLine.to.pointDiff = pointDiff;
  };
  this.getNextLine = (line, index, shouldSearchAmongLinesWithoutAngles) => {
    const lines = shouldSearchAmongLinesWithoutAngles ? this.getLinesWithoutAngle() : shape;
    index = index || lines.indexOf(line);
    let next = index + 1;
    if (index === lines.length - 1) {
      next = 0;
    }
    return lines[next];
  };
  this.getPrevLine = function(line, index) {
    index = index || shape.indexOf(line);
    var prev = index - 1;
    if (index === 0) {
      prev = shape.length - 1;
    }
    return shape[prev];
  };
  this.getAngleDirection = function(line) {
    var index = shape.indexOf(line);
    var lines = {
      line1: shape[index],
      line2: this.getNextLine(line, index),
      lineBefore: this.getPrevLine(line, index)
    };
    return getPointDirection(lines.line1.from, lines.line1.to, lines.line2.to, lines.lineBefore.from);
  };
  this.flip = function(flipDirection) {
    let i;
    switch(flipDirection) {
      case self.FlipDirection.HORIZONTAL:
        var max_y = 0;
        for (i = 0; i < shape.length; i++) {
          if (max_y < shape[i].from.y) {
            max_y = shape[i].from.y;
          }
        }
        for (i = 0; i < shape.length; i++) {
          shape[i].from.y = max_y - shape[i].from.y;
        }
        break;
      case self.FlipDirection.VERTICAL:
        var max_x = 0;
        for (i = 0; i < shape.length; i++) {
          if (max_x < shape[i].from.x) {
            max_x = shape[i].from.x;
          }
        }
        for (i = 0; i < shape.length; i++) {
          shape[i].from.x = max_x - shape[i].from.x;
        }
        break;
    }
  };
  this.rotate = (degrees, direction, isSlabMode = false, aroundPoint = null) => {
    // todo fix bumpout rotation and remove this
    // if (self.isWithBumpout() || self.isWithMitered()) {
    //   return
    // }
    /////////////////////////////////////////
    isSlabMode ? this.rotatedDegreesSlab += degrees : this.rotatedDegrees += degrees;
    (this.rotatedDegrees === 360) && (this.rotatedDegrees = 0);
    (this.rotatedDegreesSlab === 360) && (this.rotatedDegreesSlab = 0);

    direction = direction || self.Direction.Right;
    let angle = (degrees * Math.PI / 180);
    if (direction === self.Direction.LEFT)
      angle *= -1;

    if (!aroundPoint) {
      aroundPoint = this.getCenter();
    }
    //console.log('degrees', degrees);
    //console.log('aroundPoint', aroundPoint);
    for (let i = 0; i < shape.length; i++) {
      shape[i].from.rotate(aroundPoint, angle, isSlabMode);
    }
    for (let i = 0; i < shape.length; i++) {
      let line1 = this.getAngleDirection(shape[i]),
        count = ((i - 1) < 0) ? shape.length - 1 : i - 1,
        line2 = this.getAngleDirection(shape[count]);

      shape[i].from.changeCornerDirection(line1, line2);
    }

    this.rotateOriginalPointCords(aroundPoint, angle);
    this.rotateInflectionPoints(aroundPoint, angle);
    this.rotateShapeBumpoutPoints(aroundPoint, angle, isSlabMode); //todo
    if (this.shapeRotatable) {
      this.shapeRotatable.rotateShapeRotatablePoints(aroundPoint, angle, isSlabMode);
    }
    if (!isSlabMode) {
      this.setIsPointsChanged(true);
    }
  };
  this.rotateOriginalPointCords = (aroundPoint, angle) => {
    this.originalPointsCoords = this.originalPointsCoords.map(pointCoords => {
      return getRotatedPointV1(pointCoords, aroundPoint, angle);
    })
  }
  this.rotateInflectionPoints = (aroundPoint, angle) => {
    if (this.inflectionPoints) {
      this.inflectionPoints = this.inflectionPoints.map(pointCoords => {
        return getRotatedPointV1(pointCoords, aroundPoint, angle);
      })
    }
  }
  this.rotateShapeBumpoutPoints = (aroundPoint, angle, isSlabMode) => {
    if (this.isWithBumpout()) {
      for (const line of this.getLines()) {
        if (line.isWithBumpout()) {
          const bumpoutPoints = line.bumpoutOverlay.getBumpoutPoints();
          for (const bumpoutPointsKey in bumpoutPoints) {
            if (bumpoutPoints.hasOwnProperty(bumpoutPointsKey)) {
              bumpoutPoints[bumpoutPointsKey].rotate(aroundPoint, angle, isSlabMode);
            }
          }
        }
      }
    }
  }
  this.setRotationDegrees = (rotationDegrees) => {
    this.rotatedDegrees = rotationDegrees
  }
  this.updateSlabPoints = () => {
    for (let i = 0; i < shape.length; i++) {
      shape[i].from.posSlab.x = JSON.parse(JSON.stringify(shape[i].from.pos.x));
      shape[i].from.posSlab.y = JSON.parse(JSON.stringify(shape[i].from.pos.y));
      if (shape[i].isWithBumpout()) {
        //this is used to reset additional bumpout shape
        SlabWorkspace.slabAdditionalShapes.removeActiveBacksplashByLine(shape[i]);

        //this is used to reset bumpoutPoints if they displayed with the line
        const bumpoutPoints = shape[i].bumpoutOverlay.getBumpoutPoints();
        for (let point in bumpoutPoints) {
          bumpoutPoints[point].posSlab = clone(bumpoutPoints[point].pos);
        }
      }
    }
  }
  this.updateSlabPosition = () => {
    this.setSlabPosition(this.pos);
  }
  this.init = (position, segments) => {
    if (position) {
      this.setPositionWithoutChange(position);
      this.setSlabPosition(position);
    }
    if (SHAPE_PART_IDS_VISIBLE_ONLY_IN_THE_SLAB_MODE.includes(this.partId)) {
      this.isPositionChanged = false;
    }

    if (segments) {
      this.setLines(segments);
    }

    // that hook is for resizing, perhaps we should rewrite resizing and remove this
    if (self.layout270.indexOf(this.fromLayout) !== -1) {
      self.rotatedDegrees = 270;
    }

    function getRandomInt(min, max) {
      return Math.floor(Math.random() * (max - min)) + min;
    }
    totalShapeCount && setFillColor(getRandomInt(0, 255), getRandomInt(0, 255), getRandomInt(0, 255), 0.3);
    this.initEvents(sqftEventManager);
  };
  this.getPriority = (eventManager) => {
    switch (this.partId) {
      case SHAPE_PART_ID.upper_cabinet_boxes: return eventManager.priorities.SHAPE_UPPER
      case SHAPE_PART_ID.slabPlaceHolder: return eventManager.priorities.SHAPE_SLAB_PLACEHOLDER
      default: return eventManager.priorities.SHAPE
    }
  }
  this.initEvents = (eventManager = sqftEventManager) => {
    eventManager.addEvent(
      eventManager.events.MOUSE_MOVE,
      onMouseMove,
      this,
      this.getPriority(eventManager)
    );
    eventManager.addEvent(
      eventManager.events.MOUSE_DOWN,
      onMouseDown,
      this,
      this.getPriority(eventManager)
    );
    eventManager.addEvent(
      eventManager.events.MOUSE_UP,
      onMouseUp,
      this,
      this.getPriority(eventManager)
    );
    eventManager.addEvent(
      eventManager.events.RENDER,
      this.render,
      this,
      this.getPriority(eventManager)
    );
    eventManager.addEvent(
      eventManager.events.DBLCLICK,
      onDblClick,
      this,
      this.getPriority(eventManager)
    );
    eventManager.addEvent(
      eventManager.events.CONTEXTMENU,
      onContextmenu,
      this,
      this.getPriority(eventManager)
    );
  };
  this.resetState = () => {
    state.mouseDown = false;
    state.mouseDownPosition = null;
    state.hovering = false;
    state.handlerHold = null;
  };
  this.deregisterEvents = () => {
    sqftEventManager.removeEvent(this);
    this.resetState();
    this.isHidden = true;
    this.deregisterLineEvents();
  };
  this.deregisterLineEvents = () => {
    for (let i = 0; i < shape.length; i++) {
      shape[i].deregisterEvents();
    }
  };
  this.reInitLineTitleEvents = () => {
    for (let i = 0; i < shape.length; i++) {
      shape[i].reInitTitleEvents();
    }
  };
  this.reInitEvents = () => {
    if (this.isHidden) {
      this.initEvents(sqftEventManager);
      this.restoreState();
      this.isHidden = false;
      for (let i = 0; i < shape.length; i++) {
        shape[i].reInitEvents();
      }
    }
  };
  this.deregisterPartEvents = () => {
    for (let i = 0; i < shape.length; i++) {
      shape[i].deregisterPartEvents();
    }
  };
  this.reInitPartEvents = () => {
    for (let i = 0; i < shape.length; i++) {
      shape[i].reInitPartEvents();
    }
  };
  this.restoreState = () => {
    state = {
      mouseDown: false,
      mouseDownPosition: null,
      hovering: false,
      handlerHold: null
    };
  };
  this.destroy = (protect) => {
    if (!protect) {
      for (var i = 0; i < shape.length; i++) {
        shape[i].destroy();
      }
      if (this.shapeRotatable) {
        sqftShapeManager.disableRotatableState(this);
      }
      sqftEventManager.removeEvent(self);
      workspaceControllers.handles.deleteAllResourcesForTheShape(this.id);
      workspaceControllers.hinge.deleteAllResourcesForTheShape(this.id);
      for (const seamCutPointsAndLine of this.seamCutPointsAndLines) {
        seamCutPointsAndLine.destroy();
      }
    }
  };
  this.stealCursor = function(who) {
    for (var i = 0; i < shape.length; i++) {
      if (shape[i] === who) {
        sqftEventManager.resetCursor(self);
      }
    }
  };
  this.resetCursor = function() {
    sqftEventManager.resetCursor(self);
  };
  this.isShapeHasIntersections = () => {
    return shape.some(line => {
      return line.hasIntersections();
    })
  }
  this.renderAnglePartActive = function(rotateAnglePart, ctx) {
    ctx.save();
    ctx.beginPath();
    const rotateShape1 = getRotateAngleRectangle(rotateAnglePart);
    ctx.moveTo(rotateShape1[0][0], rotateShape1[0][1]);
    ctx.lineTo(rotateShape1[1][0], rotateShape1[1][1]);
    ctx.lineTo(rotateShape1[2][0], rotateShape1[2][1]);
    ctx.lineTo(rotateShape1[3][0], rotateShape1[3][1]);
    ctx.closePath();
    ctx.fillStyle = "rgba(159, 198, 33, 0.5)";
    ctx.fill();
    ctx.restore();
  };

  this.isAngleRotatedPartsWithCorner = (rotateAnglePart) => {
    let line1 = self.getPrevLine(shape[rotateAnglePart.line1]);
    let line2 = shape[rotateAnglePart.line2];

    if ((self.shapeType === "horseshoe" || self.shapeType === "wideangle")
      && rotateAnglePart.line1 > rotateAnglePart.line2
    ) {
      line1 = shape[rotateAnglePart.line1];
      line2 = self.getPrevLine(shape[rotateAnglePart.line2]);
    }

    return [line1, line2].some((line) => {
      return line.to.angle > 0 || line.to.arcLength > 0
    });
  }

  this.render = (ctx) => {
    this.shapeRender.render(ctx)
  }

}
